module.exports = __webpack_public_path__ + "img/imagen_parrafo_3.670e2963.jpg";